import { Button } from "antd";

import "./filters.scss"
import AppliedFilters from "components/common/AppliedFilters";

interface LiveCallsAppliedFiltersProps {
    handleClearFilters: () => void;
    handleRemoveFilter?: (key: string) => void;
    filters: any
}

export default function LiveCallsAppliedFilters({ handleClearFilters, handleRemoveFilter, filters }: LiveCallsAppliedFiltersProps) {
    const hasAny = Boolean(
        (filters.extensions && filters.extensions.length) ||
        (filters.phoneNumbers && filters.phoneNumbers.length) ||
        filters.direction || filters.callerIdNumber || filters.callRecording !== null
    )

    if (!hasAny) return null

    const pills: { key: string; label: string, value?: string }[] = []
    if (filters.extensions && filters.extensions.length) pills.push({ key: 'extensions', label: 'Extensions' })
    if (filters.phoneNumbers && filters.phoneNumbers.length) pills.push({ key: 'phoneNumbers', label: 'Phone Numbers' })
    if (filters.direction) pills.push({ key: 'direction', label: 'Direction', value: filters.direction })
    if (filters.callerIdNumber) pills.push({ key: 'callerIdNumber', label: 'Caller ID Number' })
    if (filters.callRecording !== null) pills.push({ key: 'callRecording', label: 'Call Recording', value: filters.callRecording ? "Yes" : "No" })

    return (
        <AppliedFilters pills={pills} handleClearFilters={handleClearFilters} handleRemoveFilter={handleRemoveFilter} />
    )
}